// import React, { useState } from 'react';
import { io } from 'socket.io-client';
// import sockeIOClient, { io, Socket } from 'socket.io-client';
import * as CryptoJS from 'crypto-js';
import axios from 'axios';

import IUser from '../models/user.model';

const URL_V3_API = "https://api.squaregolf.com/v3";
const URL_LOGIN = "ws://login.squaregolf.com:3100/"

class _AuthService {
  signin = async(username: string, password: string) => {
    let hashed = CryptoJS.SHA256(password).toString();

    // console.log(`AuthService.signin:: username: ${username}, password: ${password} -> ${hashed}`);

    return axios.post(URL_V3_API + "/auth/signin", {
        username: username,
        password: hashed
      }, {
        withCredentials: true
      })
      .then((res) => {
        // console.log(`singin -> ${JSON.stringify(res.data, null, 2)}`);
        if (res && res!.data) {
          if (res.data.user) {
            const user = res!.data.user as IUser;

            // console.log(`user -> ${JSON.stringify(user, null, 2)}`);

            if (user) {
              localStorage.setItem("sub", user.uuid!);
              // localStorage.setItem("user", JSON.stringify(user));
            }
          }
          if (res.data.access_token) {
            const accessToken = res.data.access_token as string;

            // console.log(`accessToken -> ${accessToken}`);

            localStorage.setItem("accessToken", accessToken);
          }
        }

        return res;
      });
  }

  signout(uuid: string) {
    console.log(`AuthService.signout: uuid: ${uuid}`);

    const userStr = localStorage.getItem("user");
    const terminalId = localStorage.getItem("terminalId");

    if (userStr && terminalId) {
      let user = JSON.parse(userStr);

      this.remoteSignOut(user.username, terminalId);

      localStorage.removeItem("terminalId");
    }

    localStorage.removeItem("user");
    window.sessionStorage.removeItem("user");

    localStorage.removeItem("accessToken");
    localStorage.removeItem("sub");
  }

  getCurrentUser() {
    const userStr = localStorage.getItem("user");

    // console.log(`AuthService.getCurrentUser:: userStr: ${userStr}`);
    
    if (userStr) { 
      return JSON.parse(userStr);
    }

    return null as any;
  }

  getCurrentRemote() {
    const userStr = localStorage.getItem("user");
    
    if (userStr) { 
      return JSON.parse(userStr);
    }

    return null;
  }

  remoteSignIn(username: string, accessToken: string, terminalId: string) {
    console.log(`AuthService.remoteSignin`);

    localStorage.setItem("terminalId", terminalId);

    const s = io(URL_LOGIN, {
      transports: ['websocket'],
      reconnectionDelayMax: 10000,
      auth: {
        token: "undefined",
      },
      query: {
        "key": "value",
      }
    });

    s.on('connect', () => {
      console.log(`ws: connect`);
      
      s.emit('login', {
        username: username,
        accessToken: accessToken,
        terminalId: terminalId,
      });

      s.on('close', (reason: string) => {
        console.log(`ws: close (${reason})`);
      });
    });

    return null;
  }

  remoteSignOut(username: string, terminalId: string) {
    console.log(`AuthService.remoteSignout`);

    const s = io(URL_LOGIN, {
      transports: ['websocket'],
      reconnectionDelayMax: 10000,
      auth: {
        token: "undefined",
      },
      query: {
        "key": "value",
      }
    });

    s.on('connect', () => {
      console.log(`ws: connect`);
      
      s.emit('logout', {
        username: username,
        terminalId: terminalId,
      });

      s.on('close', (reason: string) => {
        console.log(`ws: close (${reason})`);
      });
    });

    return null;
  }
}


const AuthService = new _AuthService();
export default AuthService;
